import { render } from "./ConfirmUserRequestSendMoney.vue?vue&type=template&id=2d01fa66"
import script from "./ConfirmUserRequestSendMoney.vue?vue&type=script&lang=js"
export * from "./ConfirmUserRequestSendMoney.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__